module.exports = __webpack_public_path__ + "static/media/united-states-of-america.936feee6.svg";